import { useGetQuery } from 'common/hooks';
import { useRecoilValue } from 'recoil';
import { organizationAtom } from 'services/organization/atom';
import { ApiPaths } from '../constants/apiPaths';

export const useFetchCustomerContractDashboardUrl = () => {
  const organization = useRecoilValue(organizationAtom);
  const orgGroupId = organization?.organizationGroupId;

  return useGetQuery<{ url: string }>(ApiPaths.customerContractDashboardUrl, {
    queryKey: [ApiPaths.customerContractDashboardUrl, orgGroupId],
    enabled: !!orgGroupId
  });
};
